import { AnyAbility } from '@casl/ability';
import { Action } from '../models/configurableTable';

export const actionPermissionFilter = (ability: AnyAbility) => (action: Action) => {
  if (action.type === 'separtor') {
    return true;
  }

  return !(
    action.permission && ability.cannot(action.permission.action, action.permission.subject)
  );
};
